export async function getCaptchaV3Token(action = "submit") {
	const sitekey = window.RECAPTCHA_SITE_KEY || '';
	if (!sitekey || sitekey === 'stub-site-key') return

  if (typeof grecaptcha === "undefined") {
    console.error("reCAPTCHA API не загружена");
    return null;
  }

  try {
    await new Promise((resolve) => grecaptcha.ready(resolve)); 
    const token = await grecaptcha.execute(sitekey, { action });
    return token;
  } catch (err) {
    console.error("Ошибка получения reCAPTCHA токена:", err);
    return null;
  }
}
